var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5258 21.1052C37.5258 25.0294 34.3445 28.2103 30.4206 28.2103C26.4967 28.2103 23.3154 25.0294 23.3154 21.1052C23.3154 17.1812 26.4967 14 30.4206 14C34.3445 14 37.5258 17.1812 37.5258 21.1052Z",
    fill: "#69CD92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8413 43.2105C43.8413 35.8028 37.8281 29.7898 30.4207 29.7898C23.0132 29.7898 17 35.803 17 43.2105C17 43.6464 17.3537 44 17.7893 44H43.0526C43.4882 44 43.8418 43.6464 43.8418 43.2105H43.8413Z",
    fill: "#69CD92"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardUserIcon);
export default __webpack_public_path__ + "static/media/dashboard-user-icon.58e52634be6f6eea2bacfb9cd8f82af9.svg";
export { ForwardRef as ReactComponent };